import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'DesktopNav',
})(({ brandColors, type, breakpoints, zLevels, spacing, typography }) => ({
  navLinks: {
    display: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    [breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  logo: {
    margin: `${typography.pxToRem(5)} ${typography.pxToRem(15)}`,
  },
  navLink: {
    cursor: 'pointer',
    flexDirection: 'column',
    alignItems: 'center',
    gap: typography.pxToRem(8),
    ...type['16_medium'],
    position: 'relative',
    margin: `${typography.pxToRem(24)} ${typography.pxToRem(
      10
    )} ${typography.pxToRem(21)} ${typography.pxToRem(10)}`,
    paddingBottom: spacing(-1),
    zIndex: zLevels.dropdown,
    [breakpoints.up('lg')]: {
      margin: `${typography.pxToRem(32)} ${spacing(1)} ${typography.pxToRem(
        21
      )} ${spacing(1)}`,
      paddingBottom: spacing(-1),
    },

    '&:after': {
      content: '""',
      position: 'absolute',
      width: '100%',
      transform: 'scaleX(.5)',
      opacity: 0,
      height: typography.pxToRem(3),
      bottom: 0,
      left: 0,
      background: brandColors.primaryMain,
      borderRadius: typography.pxToRem(70),
      transformOrigin: 'center',
      transition: 'transform 0.25s ease-out',
    },
  },
  navLinkSelected: {
    '&:after': {
      transform: 'scaleX(1)',
      transformOrigin: 'center',
      opacity: 1,
    },
  },
  buttonWrapper: {
    height: typography.pxToRem(44),
    width: typography.pxToRem(116),
    float: 'right',
    [breakpoints.up('md')]: {
      height: 'inherit',
    },
    '& div': {
      height: '100%',
      '& a': {
        height: '100%',
        textDecoration: 'none',
      },
    },
  },
  drawerLocationContainer: {
    width: typography.pxToRem(400),
  },
  locationDesktopHeader: {
    borderBottom: `4px solid ${brandColors.primaryMain}`,
    textAlign: 'center',
    position: 'relative',
    zIndex: zLevels.fixed,
    padding: `${typography.pxToRem(16)} ${typography.pxToRem(24)}`,
    '& h3': { ...type['18_medium'] },
  },
  locationDesktopHeaderDark: {
    color: brandColors.white,
  },
  locationCloseContainer: {
    position: 'absolute',
    top: typography.pxToRem(20),
    right: typography.pxToRem(24),
    zIndex: zLevels.fixed,
  },
}));

export default useStyles;
